<template>
    <el-dialog class="claim-dialog"
               width="950px"
               :visible.sync="showDialog"
               append-to-body
               @open="loadClaim"
               @close="closeDialog"
               :close-on-click-modal="false">
        <template slot="title">
            Preview claim {{claim.claimNumber}}
            <el-select v-if="$isFullAdmin && !isForPartial"
                       v-on:change="handleStatusChange(claim.id, claimStatus)"
                       v-model="claimStatus"
                       :disabled="claim.status === 'Paid' || noDetails">
                <el-option :label="$t('common.new')"
                           value="1"></el-option>
                <el-option :label="$t('common.acceptAndProcess')"
                           value="2"></el-option>
                <el-option :label="$t('common.moreinfoRequired')"
                           value="3"></el-option>
                <el-option :label="$t('common.rejected')"
                           value="4"></el-option>
                <el-option :label="$t('common.paid')"
                           value="6"></el-option>
                <el-option :label="$t('common.pendingReturnPart')"
                           value="7"></el-option>
                <el-option :label="$t('common.pendingRepairCodeCorrections')"
                           value="8"></el-option>
                <el-option :label="$t('common.correctedRepairCodes')"
                           value="9"></el-option>
                <el-option :label="$t('common.pendingTechnicalReview')"
                           value="10"></el-option>
                <el-option :label="$t('common.pendingTechnicalReviewGillesB')"
                           value="11"></el-option>
            </el-select>
            <el-button v-if="!noDetails && !isForPartial && (claim.status === 'Partial' || claim.status === 'MoreInformationRequired' || $isAdmin)"
                       @click="editClaim(claim.id)">
                <!--:disabled="!(claim.status === 'Partial' || claim.status === 'MoreInformationRequired') && $isUser"-->
                {{$t('common.details')}}
            </el-button>
        </template>
        <div v-loading="loading">
            <el-row v-if="claim.serviceCompany || claim.customer">
                <el-col v-if="claim.serviceCompany.code != null"
                        :span="8">
                    <h4>{{$t('common.serviceCompany')}}</h4>
                    <p>{{claim.serviceCompany.name}}</p>
                    <p>{{claim.serviceCompany.code}}</p>
                    <p>{{claim.serviceCompany.street}}</p>
                    <p>{{claim.serviceCompany.city}}, {{claim.serviceCompany.zip}} {{claim.serviceCompany.stateCode}}</p>
                    <p> {{claim.serviceCompany.phone}}</p>
                    <p>{{claim.serviceCompany.contactPersonName}}</p>
                    <div v-if="claim.serviceCompany.subContractorName != null">
                        <b>{{$t('common.subContractor')}}</b>
                        <p>{{claim.serviceCompany.subContractorName}}</p>
                        <p>{{claim.serviceCompany.subContractorPhone}}</p>
                        <p>{{claim.serviceCompany.subContractorEmail}}</p>
                        <p>{{claim.serviceCompany.subContractorContactName}}</p>
                    </div>
                </el-col>
                <el-col v-if="claim.customer.name != null"
                        :span="8">
                    <h4>{{$t('claims.siteInformation')}}</h4>
                    <p>{{claim.customer.name}}</p>
                    <p>{{claim.customer.street}}</p>
                    <p>{{claim.customer.city}}, {{claim.customer.zip}} {{claim.customer.code}}</p>
                    <p>{{claim.customer.phone}}</p>
                </el-col>
                <el-col :span="8">
                    <h4>{{$t('common.claimInformation')}}</h4>
                    <p v-if="claim.serviceTicketNumber != null">
                        <b>{{$t('common.serviceTicketNumColon')}}</b> {{claim.serviceTicketNumber}}
                    </p>
                    <p>
                        <b>{{$t('common.claimColon')}}</b> {{claim.claimNumber}}
                    </p>
                    <p>
                        <b>{{$t('common.statusColon')}}</b> {{claim.status}}
                    </p>
                    <p>
                        <b>{{$t('common.createdColon')}}</b> {{claim.raisedOn | date}}
                    </p>
                    <p>
                        <b>{{$t('common.dispatchColon')}}</b> {{claim.dateOfDispatch | date}}
                    </p>
                    <p v-if="claim.acceptedDate != null">
                        <b>{{$t('common.acceptedDateColon')}}</b> {{claim.acceptedDate | date}}
                    </p>
                    <p>
                        <b>{{$t('common.workCompletedColon')}}</b> {{claim.dateWorkCompleted | date}}
                    </p>
                    <br />
                    <p>
                        <b>{{$t('common.invoiceColon')}}</b> {{claim.invoiceNumber}}
                    </p>
                    <p>
                        <b>{{$t('common.serviceWorkOrderColon')}}</b> {{claim.serviceWorkOrder}}
                    </p>
                    <p>
                        <b>{{$t('common.serviceCoverage')}}</b> {{claim.serviceCoverage}}
                    </p>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <p v-if="claim.subAgent != null">
                        <b>{{$t('common.subAgentColon')}}</b> {{claim.subAgent.name}}
                    </p>
                    <p>
                        <b>{{$t('common.serviceTicketNumber')}}</b> {{claim.serviceTicketId}}
                    </p>
                    <p>
                        <b>{{$t('common.serviceRequestedBy')}}</b> {{claim.serviceRequestedBy}}
                    </p>
                    <p>
                        <b>{{$t('common.workOrderSignedAndApprovedBy')}}</b> {{claim.orderSignedBy}}
                    </p>
                    <p>
                        <b>{{$t('claims.serviceTechnicianName')}}</b> {{claim.technicianName}}
                    </p>
                </el-col>
                <el-col :span="8">
                    <p>
                        <b>{{$t('common.productModelColon')}}</b> {{claim.product}}
                    </p>
                    <p>
                        <b>{{$t('common.serialColon')}}</b> {{claim.serialNumber}}
                    </p>
                    <p>
                        <b>{{$t('common.reportSymptomsColon')}}</b> {{claim.complaint}}
                    </p>
                    <p v-if="claim.processedBy != null">
                        <b>{{$t('common.processedByColon')}}</b> {{ showProcessedByUser() }}
                    </p>
                </el-col>
            </el-row>
        </div>
        <div class="preview"
             v-loading="loading">
            <!-- <el-row :gutter="20">
                <el-col :span="12">
                    <p><b>Service Work Order</b> {{claim.serviceWorkOrder}}</p>
                    <p><b>{{$t('common.invoiceNumber')}}</b> {{claim.invoiceNumber}}</p>
                    <p><b>{{$t('common.serviceCoverage')}}</b> {{claim.serviceCoverage}}</p>
                    <p><b>{{$t('common.dateOfDispatch')}}</b> {{claim.dateOfDispatch | date}}</p>
                    <p><b>Date Work Completed</b> {{claim.dateWorkCompleted | date}}</p>
                    <p><b>Product</b> {{claim.product}}</p>
                    <p><b>{{$t('common.serialNumber')}}</b> {{claim.serialNumber}}</p>
                    <p><b>Is 90 Days Warranty</b> {{claim.is90DaysWarranty}}</p>
                    <p><b>Work Orders</b> <a v-for="order in claim.workOrders" :key="order.id" :href="order.url" target="_blank">{{order.name}}</a></p>
                </el-col>
                <el-col :span="8">
                    <p><b>{{$t('common.customer')}}</b> {{claim.customer ? claim.customer.name : ''}}</p>
                    <p><b>Order Signed By</b> {{claim.orderSignedBy}}</p>
                    <p><b>{{$t('common.technicianName')}}</b> {{claim.technicianName}}</p>
                    <p><b>{{$t('common.serviceRequestedBy')}}</b> {{claim.serviceRequestedBy}}</p>
                    <p><b>Complaint</b> {{claim.complaint}}</p>
                </el-col>
                <el-col :span="4">
                    <el-button size="mini" @click="editClaim(claim.id)">
                        <i class="el-icon-edit"></i>Details
                    </el-button>
                </el-col>
            </el-row> -->
            <h4>{{$t('common.codes')}}</h4>
            <el-table :data="claim.repairCodes"
                      size="mini"
                      class="tablewithshading">
                <el-table-column prop="code"
                                 :label="$t('common.code')"
                                 width="100"></el-table-column>
                <el-table-column prop="description"
                                 :label="$t('common.description')"></el-table-column>
                <el-table-column prop="regularTime"
                                 :label="$t('common.regularTime')"
                                 width="100"></el-table-column>
            </el-table>

            <h4>{{$t('common.laborAndTravel')}}</h4>
            <el-table :data="claim.laborTravel"
                      size="mini"
                      class="tablewithshading">
                <el-table-column prop="name"
                                 label=""></el-table-column>
                <el-table-column :label="$t('common.regularTime')">
                    <el-table-column prop="regular"
                                     :label="$t('common.maxAllowed')"></el-table-column>
                    <el-table-column prop="supplementary"
                                     :label="$t('common.suplementary')"></el-table-column>
                    <el-table-column :label="$t('common.rate')">
                        <template slot-scope="scope">
                            {{scope.row.rate}}
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('common.total')">
                        <template slot-scope="scope">
                            {{scope.row.total}}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column :label="$t('common.overTime')">
                    <el-table-column prop="overtime"
                                     :label="$t('common.maxAllowed')"></el-table-column>
                    <el-table-column prop="supplementaryOvertime"
                                     :label="$t('common.suplementary')"></el-table-column>
                    <el-table-column :label="$t('common.rate')">
                        <template slot-scope="scope">
                            {{scope.row.rateOvertime}}
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('common.total')">
                        <template slot-scope="scope">
                            {{scope.row.totalOvertime}}
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>


            <table class="trips-table">
                <tr>
                    <th>{{$t('claims.numberOfTrips')}}</th>
                    <th>{{$t('common.tripsExplanation')}}</th>
                </tr>
                <tr>
                    <td>{{claim.numberOfTrips}}</td>
                    <td>{{claim.tripsExplanation}}</td>
                </tr>
            </table>

            <h4 v-if="claim.parts && claim.parts.length > 0">{{$t('common.parts')}}</h4>
            <el-table :data="claim.parts"
                      size="mini"
                      class="tablewithshading"
                      v-if="claim.parts && claim.parts.length > 0">
                <el-table-column prop="no"
                                 :label="$t('common.no')"></el-table-column>
                <el-table-column prop="description"
                                 :label="$t('common.description')"></el-table-column>
                <el-table-column prop="quantity"
                                 :label="$t('common.quantity')"></el-table-column>
                <el-table-column prop="price"
                                 :label="$t('common.price')">
                    <template slot-scope="scope">
                        {{scope.row.price | money}}
                    </template>
                </el-table-column>
                <el-table-column prop="extendedPrice"
                                 :label="$t('common.extendedPrice')">
                    <template slot-scope="scope">
                        {{scope.row.extendedPrice | money}}
                    </template>
                </el-table-column>
                <el-table-column prop="total"
                                 :label="$t('common.extendedTotal')"></el-table-column>
            </el-table>

            <h4 v-if="claim.miscParts && claim.miscParts.length > 0">{{$t('claims.miscParts')}}</h4>
            <el-table :data="claim.miscParts"
                      size="mini"
                      class="tablewithshading"
                      v-if="claim.miscParts && claim.miscParts.length > 0">
                <el-table-column prop="name"
                                 :label="$t('claims.partName')"></el-table-column>
                <el-table-column :label="$t('common.price')">
                    <template slot-scope="scope">
                        {{scope.row.price | money}}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('common.extendedPrice')">
                    <template slot-scope="scope">
                        {{scope.row.extendedPrice | money}}
                    </template>
                </el-table-column>
                <el-table-column prop="quantity"
                                 :label="$t('common.quantity')"></el-table-column>
            </el-table>

            <table class="nowrap totals"
                   style="width: auto">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{$t('common.total')}}</th>
                        <th v-if="claim.isWarrantyClaim">{{$t('common.glCode')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{$t('common.laborAndTravel')}}</td>
                        <td>{{claim.laborTotal | money}}</td>
                        <td v-if="claim.isWarrantyClaim">{{claim.laborGLCode}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('common.parts')}}</td>
                        <td>{{claim.partsTotal | money}}</td>
                        <td v-if="claim.isWarrantyClaim">{{claim.partGLCode}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('common.freight')}}</td>
                        <td>{{claim.freight | money}}</td>
                        <td v-if="claim.isWarrantyClaim">{{claim.freightGLCode}}</td>
                    </tr>
                    <tr v-if="claim.tax && (claim.taxId === null)">
                        <td>{{$t('common.taxEIN')}}</td>
                        <td>{{claim.tax | money}}</td>
                        <td></td>
                    </tr>
                    <tr v-if="claim.freight > 50">
                        <td>{{$t('common.hardtOriginalInvColon')}}</td>
                        <td>{{claim.hardtInvoice}}</td>
                        <td></td>
                    </tr>
                    <tr v-if="claim.isUS && claim.tax && (claim.taxId !== null)">
                        <td>{{$t('common.taxEINNum')}}{{claim.taxId}}</td>
                        <td>{{claim.tax | money}}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{{$t('claims.handling')}}</td>
                        <td>{{claim.handling | money}}</td>
                        <td v-if="claim.isWarrantyClaim">{{claim.handlingGLCode}}</td>
                    </tr>

                    <tr v-if="claim.isCanadian">
                        <td>{{$t('common.gstHstNum')}}{{claim.gstNumber}}</td>
                        <td>{{claim.gst | money}}</td>
                        <td></td>
                    </tr>
                    <tr v-if="claim.isQuebec">
                        <td>{{$t('common.pstNum')}}{{claim.qstNumber}}</td>
                        <td>{{claim.qst | money}}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <b>{{$t('common.total')}}</b>
                        </td>
                        <td>
                            <b>{{claim.total | money }}</b>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <div v-if="isUserServiceCompany">
                <h4 v-if="claim.comments && claim.comments.length > 0">{{$t('common.comments')}}</h4>
                <el-scrollbar style="margin: 10px;">
                    <ul class="comment-box">
                        <li v-for="comment in claim.comments"
                            :key="comment.id">
                            <div>
                                <p>{{comment.text}}</p>
                                <strong>On {{comment.on | date}} by {{comment.by ? comment.by.name : "--MISSING--"}}</strong>
                            </div>
                        </li>
                    </ul>
                </el-scrollbar>
            </div>
        </div>
        <span slot="footer"
              v-if="!isForPartial">
            <el-button @click="editClaim(claim.id)"
                       v-if="!noDetails && (claim.status === 'Partial' || claim.status === 'MoreInformationRequired' || $isAdmin)">
                <i class="el-icon-edit"></i>{{$t('common.details')}}
            </el-button>
            <el-button @click="printClaim()"
                       :loading="printing">
                <i class="el-icon-printer"></i>
            </el-button>
            <el-button v-if="!hideSave && $isAdmin && !noDetails"
                       type="primary"
                       @click="save">{{$t('common.process')}}</el-button>
            <el-button @click="closeDialog">{{$t('common.close')}}</el-button>
        </span>
        <span slot="footer"
              v-else>
            <el-button @click="closeDialog">{{$t('common.back')}}</el-button>
            <el-button @click="printClaim()"
                       :loading="printing">
                <i class="el-icon-printer"></i>
            </el-button>
            <el-button @click="confirm"
                       type="primary">{{$t('common.submit')}}</el-button>
        </span>
    </el-dialog>
</template>
<script>
    import api from "../api";
    import { EventBus } from "@/app/event-bus.js";
    export default {
        name: "preview-claim-dialog",
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            claimId: {
                required: true
            },
            hideSave: {
                type: Boolean,
                default: false
            },
            noDetails: {
                type: Boolean,
                default: false
            },
            claimModel: {
                type: Object,
                default: null
            },
            isForPartial: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                claim: {
                    rates: {}
                },
                loading: false,
                printing: false,
                showDialog: this.visible,
                isUserServiceCompany: false,
                claimStatus: null
            };
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            },
            claimStatus: function(val) {
                this.claim.status = val;
            }
        },
        methods: {
            loadClaim() {
                this.loading = true;
                api.getClaimPreview(this.claimId).then(response => {
                    this.isUserServiceCompany = this.$currentUser.profile.role != "admin";
                    this.claim = response.data;
                    this.claim.taxId = this.claim.serviceCompany.taxId;
                    if (this.$i18n.locale == 'en')
                        this.claimStatus = response.data.status;
                    else
                        this.claimStatus = response.data.statusFr;
                    this.loading = false;
                });
            },
            printClaim() {
                this.printing = true;
                api.printClaim(this.claimId).then(
                    response => {
                        this.printing = false;
                        var oHiddFrame = document.createElement("iframe");
                        oHiddFrame.style.visibility = "hidden";
                        oHiddFrame.style.position = "fixed";
                        oHiddFrame.style.right = "0";
                        oHiddFrame.style.bottom = "0";
                        oHiddFrame.src = "javascript:void(0)";
                        document.body.appendChild(oHiddFrame);
                        var dstDoc =
                            oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                        dstDoc.write(response.data);
                        dstDoc.close();
                        var isFirefox = typeof InstallTrigger !== "undefined";
                        if (isFirefox) {
                            oHiddFrame.contentWindow.print();
                            document.body.removeChild(oHiddFrame);
                        } else {
                            setTimeout(function () {
                                oHiddFrame.contentWindow.print();
                                document.body.removeChild(oHiddFrame);
                            }, 500);
                        }
                    },
                    () => (this.printing = false)
                );
            },
            closeDialog() {
                this.showDialog = false;
                for (var property in this.claim) {
                    if (this.claim.hasOwnProperty(property)) {
                        switch (typeof this.claim[property]) {
                            case "string":
                                this.claim[property] = null;
                                break;
                            case "number":
                                this.claim[property] = null;
                                break;
                            case "object":
                                this.claim[property] = null;
                                break;
                            case "undefined":
                                break;
                        }
                    }
                }
                this.$emit("dialogClosed");
            },
            save() {
                this.$confirm(this.$t('common.areYouSureYouWantToProcess'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.processClaim(this.claim.id).then(response => {
                            this.$emit("claimPublished");
                            this.closeDialog();
                        });
                    })
                    .catch(_ => { });
            },
            editClaim(id) {
                this.closeDialog();
                this.$emit("editClaim", id);
            },
            handleStatusChange(id, newStatus) {
                this.$confirm(
                    this.$t('common.areYouSureYouWantToChangeStatusOfClaim'),
                    "Warning",
                    {
                        confirmButtonText: this.$t('common.OK'),
                        cancelButtonText: this.$t('common.cancel'),
                        type: "warning"
                    }
                )
                    .then(() => {
                        api.changeStatusOfClaim(id, newStatus).then(() => {
                            if (newStatus !== 6) {
                                this.$emit("statusChanged");
                                this.$notify({
                                    title: this.$t('common.success'),
                                    message: this.$t('common.claimStatusWasUpdatedSuccesfully'),
                                    type: "success"
                                });
                            }
                            if (newStatus == 10 || newStatus == 11) {
                                api.sendEmailToReviewer(id, newStatus);
                            }
                        });
                    })
                    .catch(_ => { });
            },
            confirm() {
                // if (this.claim.status === "Partial" && this.isForPartial) {
                // api.changeStatusOfClaim(this.claim.id, 1).then(() => {
                this.loading = true;

                api.publishClaim(this.claim.id).then(() => {
                    EventBus.$emit("confirmed");
                    this.closeDialog();
                });

                // });
                // } else {
                //   this.$notify({
                //     title: "Error",
                //     message: "You can't change this claim.",
                //     type: "error"
                //   });
                // }

                this.loading = false;
            },
            showProcessedByUser() {
                if (this.claim.processedBy) {
                    return this.claim.processedBy.normalizedUserName;
                }
                return null;
            }
        }
    };
</script>

<style scoped>
    h4 {
        margin-bottom: 0;
    }

    p {
        margin: 0;
    }

    .claim-dialog > > > .el-dialog__body {
        padding: 0 20px;
    }

    .totals td:nth-child(2) {
        text-align: right;
        padding: 1px 4px 1px 4px;
    }

    .trips-table th, .trips-table td {
        text-align: left;
    }

        .trips-table th:nth-child(2), .trips-table td:nth-child(2) {
            padding-left: 180px;
        }
</style>


// WEBPACK FOOTER //
// ClientApp/app/claims/components/PreviewClaimDialog.vue